var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "419.896px",
    height: "419.896px",
    viewBox: "0 0 419.896 419.896",
    style: {
      enableBackground: "new 0 0 419.896 419.896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.713,59.54H84.18c-12.103,0-21.949,9.84-21.949,21.936v256.947c0,12.1,9.84,21.945,21.949,21.945h251.533 c12.1,0,21.945-9.84,21.945-21.945V81.476C357.652,69.38,347.812,59.54,335.713,59.54z M259.879,262.126h-42.313v-95.7 l-36.803,58.392l-36.657-58.392v95.706h-42.189V92.238h42.189l36.657,58.392l36.803-58.392h42.313V262.126z M376.87,0H43.02 C21.245,0,3.586,17.658,3.586,39.43v341.026c0,21.781,17.659,39.439,39.434,39.439h333.856c21.774,0,39.434-17.658,39.434-39.439 V39.43C416.31,17.658,398.65,0,376.87,0z M373.204,338.423c0,20.666-16.818,37.491-37.491,37.491H84.18 c-20.67,0-37.494-16.818-37.494-37.491V81.476c0-20.663,16.818-37.488,37.494-37.488h251.533c20.667,0,37.491,16.818,37.491,37.488 V338.423z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlogo);
export default __webpack_public_path__ + "static/media/mlogo.c1bebc4eff9ee2916582bc8f82ee935d.svg";
export { ForwardRef as ReactComponent };